import Toba1 from '../Toba/Toba (1).webp'
import Toba2 from '../Toba/Toba (2).webp'
import Toba3 from '../Toba/Toba (3).webp'
import Toba4 from '../Toba/Toba (4).webp'
import Toba5 from '../Toba/Toba (5).webp'
import Toba6 from '../Toba/Toba (6).webp'
import Toba7 from '../Toba/Toba (7).webp'
import Toba8 from '../Toba/Toba (8).webp'
import Toba9 from '../Toba/Toba (9).webp'
import Toba10 from '../Toba/Toba (10).webp'
import Toba11 from '../Toba/Toba (11).webp'
import Toba12 from '../Toba/Toba (12).webp'
import Toba13 from '../Toba/Toba (13).webp'
import Toba14 from '../Toba/Toba (14).webp'
import Toba15 from '../Toba/Toba (15).webp'
import Toba16 from '../Toba/Toba (16).webp'
import Toba17 from '../Toba/Toba (17).webp'
import Toba18 from '../Toba/Toba (18).webp'

const Tobaimages =[
Toba1,Toba2,Toba3,Toba4,Toba5,Toba6,Toba7,Toba8,Toba9,Toba10,Toba11,Toba12,Toba13,Toba14,Toba13,Toba14,Toba15,Toba16,Toba17,Toba18
]

export default Tobaimages;